import Api from "./Api";

const endpoint = "/statuserweiterung";
export default {
    get() {
        return Api.fetchData(endpoint);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
